// extracted by mini-css-extract-plugin
module.exports = {"faqBlock":"faqblock_faqBlock__CQeKZ","expandableText":"faqblock_expandableText__YraXp","expanded":"faqblock_expanded__rviBB"};